// ISO-3166 Country Codes.
// Source: https://en.wikipedia.org/wiki/List_of_ISO_3166_country_codes
export type Country =
  | "JP"
  | "FR"
  | "NL"
  | "GB"
  | "IE"
  | "DK"
  | "FI"
  | "SE"
  | "NO"
  | "BE"
  | "HR"
  | "CZ"
  | "SK"
  | "HU"
  | "PL"
  | "RO"
  | "RS"
  | "SI"
  | "AT"
  | "IT"
  | "PT"
  | "ES"
  | "US"
  | "AU"
  | "CN"
  | "IN"
  | "KR"
  | "UA"
  | "RU"
  | "CA"
  | "CH"
  | "DE";

// ISO-639 / BCP 47 locale codes.
// Source: https://docs.microsoft.com/en-us/openspecs/office_standards/ms-oe376/6c085406-a698-4e12-9d4d-c3b0ee3dbc4a
export type Locale =
  | "ja-JP"
  | "fr-FR"
  | "nl-NL"
  | "en-GB"
  | "ie-IE"
  | "da-DK"
  | "sv-FI"
  | "sv-SE"
  | "nn-NO"
  | "fr-BE"
  | "hr-HR"
  | "cs-CZ"
  | "sk-SK"
  | "hu-HU"
  | "pl-PL"
  | "ro-RO"
  | "sr-Latn-CS"
  | "sl-SI"
  | "de-AT"
  | "it-IT"
  | "pt-PT"
  | "es-ES"
  | "en-US"
  | "en-AU"
  | "zh-CN"
  | "en-IN"
  | "ko-KR"
  | "uk-UA"
  | "ru-RU"
  | "en-CA"
  | "fr-CH"
  | "de-DE";

// ISO 4217 currency codes.
// Source: https://en.wikipedia.org/wiki/ISO_4217
export type Currency =
  | "JPY"
  | "EUR"
  | "GBP"
  | "DKK"
  | "SEK"
  | "NOK"
  | "HRK"
  | "CZK"
  | "HUF"
  | "PLN"
  | "RON"
  | "RSD"
  | "USD"
  | "AUD"
  | "CNY"
  | "INR"
  | "KRW"
  | "UAH"
  | "RUB"
  | "CAD"
  | "CHF";

export type LocaleCurrency = {
  currency: Currency;
  locale: Locale;
};

type CountryCurrency = {
  [C in Country]: LocaleCurrency;
};

const data: CountryCurrency = {
  JP: {
    currency: "JPY",
    locale: "ja-JP"
  },
  FR: {
    currency: "EUR",
    locale: "fr-FR"
  },
  NL: {
    currency: "EUR",
    locale: "nl-NL"
  },
  GB: {
    currency: "GBP",
    locale: "en-GB"
  },
  IE: {
    currency: "EUR",
    locale: "ie-IE"
  },
  DK: {
    currency: "DKK",
    locale: "da-DK"
  },
  FI: {
    currency: "EUR",
    locale: "sv-FI"
  },
  SE: {
    currency: "SEK",
    locale: "sv-SE"
  },
  NO: {
    currency: "NOK",
    locale: "nn-NO"
  },
  BE: {
    currency: "EUR",
    locale: "fr-BE"
  },
  HR: {
    currency: "EUR",
    locale: "hr-HR"
  },
  CZ: {
    currency: "CZK",
    locale: "cs-CZ"
  },
  SK: {
    currency: "EUR",
    locale: "sk-SK"
  },
  HU: {
    currency: "HUF",
    locale: "hu-HU"
  },
  PL: {
    currency: "PLN",
    locale: "pl-PL"
  },
  RO: {
    currency: "RON",
    locale: "ro-RO"
  },
  RS: {
    currency: "RSD",
    locale: "sr-Latn-CS"
  },
  SI: {
    currency: "EUR",
    locale: "sl-SI"
  },
  AT: {
    currency: "EUR",
    locale: "de-AT"
  },
  IT: {
    currency: "EUR",
    locale: "it-IT"
  },
  PT: {
    currency: "EUR",
    locale: "pt-PT"
  },
  ES: {
    currency: "EUR",
    locale: "es-ES"
  },
  US: {
    currency: "USD",
    locale: "en-US"
  },
  AU: {
    currency: "AUD",
    locale: "en-AU"
  },
  CN: {
    currency: "CNY",
    locale: "zh-CN"
  },
  IN: {
    currency: "INR",
    locale: "en-IN"
  },
  KR: {
    currency: "KRW",
    locale: "ko-KR"
  },
  UA: {
    currency: "UAH",
    locale: "uk-UA"
  },
  RU: {
    currency: "RUB",
    locale: "ru-RU"
  },
  CA: {
    currency: "CAD",
    locale: "en-CA"
  },
  CH: {
    currency: "CHF",
    locale: "fr-CH"
  },
  DE: {
    currency: "EUR",
    locale: "de-DE"
  }
};

export default data;
